<div >
	<img [src]="documentPreviewUrl" (keydown.Escape)="cancelClicked.emit();" alt="Image not found" >
</div>

